'use client';

import { useEffect, useState } from 'react';

import { type OneTrustGroups, onOneTrustGroupsUpdated } from '../../utils';
import { hasGoogleMapsConsent } from './hasGoogleMapsConsent';

export const useGoogleMapsConsent = () => {
    const [canLoadGoogleMaps, setCanLoadGoogleMaps] = useState(false);

    useEffect(() => {
        const readConsent = (groups: OneTrustGroups = window.OnetrustActiveGroups) => {
            setCanLoadGoogleMaps(hasGoogleMapsConsent(groups));
        };

        readConsent();
        return onOneTrustGroupsUpdated(readConsent);
    }, []);

    return canLoadGoogleMaps;
};
